import { render, staticRenderFns } from "./ViewOrderForm.vue?vue&type=template&id=55224346&scoped=true&"
import script from "./ViewOrderForm.vue?vue&type=script&lang=js&"
export * from "./ViewOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderForm.vue?vue&type=style&index=0&id=55224346&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55224346",
  null
  
)

export default component.exports